import { render } from "./BindingStep0View.vue?vue&type=template&id=3a9653b1&scoped=true"
import script from "./BindingStep0View.vue?vue&type=script&lang=js"
export * from "./BindingStep0View.vue?vue&type=script&lang=js"

import "./BindingStep0View.vue?vue&type=style&index=0&id=3a9653b1&lang=less&scoped=true"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9653b1"]])

export default __exports__